import { post, get } from '../../../../services/request';

// Get all unassigned site list
export const getAllUnassignedSiteList = () => {
    return get('SiteManagement/GetAllUnAssignedSitelist');
};

// Get Practice Dropdown Data
export const getPracticeDropdownData = () => {
    return get('Common/GetPractices');
};

// Get Sub Practice Dropdown Data
export const getSubPracticeDropdownData = () => {
    return get('Common/GetSubPracticesWithGroupByPractice');
};

// Save Bulk Practice Site Data
export const saveBulkPracticeSiteData = (payload) => {
    return post('SiteManagement/SaveBulkPracticeSite', payload);
};
